// extracted by mini-css-extract-plugin
export default {"sectionFilters":"styles_sectionFilters__ad3B3"};